import client from "./client";

// أصل خادم الـAPI الصحيح. روابط المشاركة من الخادم قد تأتي نسبية إذا كان APP_PUBLIC_URL
// فارغًا في الإنتاج، فتفشل عند النسخ/المشاركة؛ لذا نحوّلها إلى روابط مطلقة هنا.
const ORIGIN = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const abs = (u) => (u && u.startsWith("/") ? `${ORIGIN}${u}` : u);

export const shareReport = async (title, html, meta = null) => {
  const d = (await client.post("/reports/share", { title, html, meta })).data;
  return { ...d, url: abs(d.url), short: abs(d.short), preview: abs(d.preview) };
};

export const updateShareHtml = (token, html) =>
  client.put(`/reports/share/${token}/html`, { html });
